/*
Getways constants FORM API
*/
export const GETWAY_CLAROCOLOMBIA = 'clarocolombiagate';
export const GETWAY_HUB = 'hubgate';
export const GETWAY_TELMEX = 'telmexmexicogate';
export const GETWAY_HUBFIJO = 'hubfijogate';
export const GETWAY_HUBFACTURAFIJA = 'hubfacturafijagate';
export const GETWAY_PROMO = 'promogate';
export const GETWAY_CREDITCARD = 'plazavipgate';
export const GETWAY_AMCO = 'amcogate';
export const GETWAY_CLAROPAGO = 'claropagosgate';
export const GETWAY_HUBCORPORATIVOFIJO = 'hubcorporativofijogate';
export const GETWAY_HUBCORPORATIVOFIJOFORM = 'hubcorporativofijogateForm';
export const GETWAY_HUBBIDERECTIONAL = 'hubbidirectional';
/*
Getway constants FROM APP
*/
export const GETWAY_SENDPIN = 'hubgate_send_pin';
export const GETWAY_PIN = 'hubgate_pin';
export const NO_GETWAY = '';
/*
Error constants
*/
export const ERR_IVR = 'error_ivr';
/*
 HTTP methods
*/
export const METHOD_POST = 'POST';
export const METHOD_GET = 'GET';
/*
Colores de los botones de pagos
*/
export const BUTTON_COLOR_DEFAULT = 'gold';
export const BUTTON_COLOR_BLUE = 'blue';
export const BUTTON_COLOR_PURPLE = 'purple';



// WEBPACK FOOTER //
// ./src/components/Payment/constants.js